import { render, staticRenderFns } from "./BSAction.vue?vue&type=template&id=5281d3bf&"
import script from "./BSAction.vue?vue&type=script&lang=js&"
export * from "./BSAction.vue?vue&type=script&lang=js&"
import style0 from "./BSAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports